import {
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table"
import { useState } from "react"

import { Table } from "~/components/table/Table"
import { FindAllActivitiesResponseDto } from "~/gen/api"
import { useColumns } from "~/pages/Admin/Ingestion/Activities/columns"

type Props = {
  activities: FindAllActivitiesResponseDto[]
}

export function Activities({ activities }: Props) {
  const columns = useColumns(activities)
  const [sorting, setSorting] = useState<SortingState>([
    { id: "id", desc: false },
  ])

  const table = useReactTable({
    data: activities,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return <Table table={table} pagination={false} />
}
